export type HsResourceType = 'HealthStatsMethod' | 'DataResource';

type HsResourceMap = {
  [key in HsResourceType]: {
    title: string;
    cardDescription: string;
    pageDescription: string;
  };
};

export const HsResource: HsResourceMap = {
  HealthStatsMethod: {
    title: 'Methods',
    cardDescription: 'Information about statistical methods and data sources used in HealthStats NSW',
    pageDescription: 'Read general and technical information about methods and data.',
  },
  DataResource: {
    title: 'Data resources',
    cardDescription: 'Find extra data resources that may help you with your analyses',
    pageDescription: 'Use extra data resources for your analyses.',
  }
};

